<template>
	<b-modal id="modal-payment-success"
		 hide-footer
		 hide-header
		 @hide="$router.push('/')"
	>
		<div class="wrap-img">
			<img src="../assets/images/ducks/send.png" alt="">
		</div>
		<div class="modal-content">
			<h2 class="title">Enjoy your Duckist Pro!</h2>
			<p class="text-center">
				Welcome to the Duckist.com family.
			</p>
		</div>
	</b-modal>
</template>

<script>
	export default {
		name: "PaymentSuccess",
		mounted() {
			// if (!localStorage.accessToken) {
			// 	this.$router.push("/")
			// }
			this.$bvModal.show('modal-payment-success')

		}
	};
</script>
<style scoped lang="scss">
	::v-deep .modal-body {
		padding: 0;
	}

	.modal-content {
		padding: 20px 25px 25px 25px;
		@include media-breakpoint-up(sm) {
			padding: 40px 50px 50px 50px;
		}

		.title {
			text-align: center;
			color: #000;
		}
	}

	.wrap-img {
		padding-top: 26px;
		padding-bottom: 26px;
		background: #21405B;
		text-align: center;
		min-height: 169px;
	}
</style>
